import type { Data } from '@/api/api.ts'
import type { PhoneLabelsList } from '@/types/callers.types.ts'
import axios from 'axios'
import { baseUrl } from '@/constants/api.ts'

const urlPrefix = `${baseUrl}callers/`

export const getUserPhoneLabelsList = async (userId: number): Promise<Data<PhoneLabelsList>> =>
  axios.get(`${urlPrefix}phone_label/list/${userId}`)

export const getUserPhoneLabelsConnectedList = async (userId: number): Promise<Data<any>> =>
  axios.get(`${urlPrefix}phone_label/connected_list/${userId}`)

export const connectPhoneLabel = async (params: any): Promise<Data<any>> =>
  axios.post(`${urlPrefix}phone_label/request-connect/`, params)
